/**
 *
 * @param addr Ethereum address
 * @returns a newly created address in the format "0xXXXX..XXXX".
 */
export const formatAddr = (addr: string): string => {
    const formatted = `${addr.slice(2, 6)}...${addr.slice(-4)}`.toUpperCase();
    return `0x${formatted}`;
};
